export default __webpack_public_path__ + "static/media/ri_arrow-drop-down-fill.06f326d2.svg";